import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import './BlogPost.css';
import { t, getLangFromPath, Lang } from '../utils/i18n';
import blogList from '../data/blogPosts';

interface BlogPostData {
  id: number;
  title: string;
  excerpt: string;
  content: string;
  image: string;
  date: string;
  category: string;
  author: string;
  readTime: string;
}

// Consolidate static posts inside component; see full list below

const BlogPost: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const lang = getLangFromPath(location.pathname, 'en');


  const post = (() => {
    const numericId = parseInt(id || '', 10);
    const listItem = blogList.find((i) => i.id === numericId);
    if (!listItem) return null;
    return {
      id: listItem.id,
      title: '',
      excerpt: '',
      content: '',
      image: listItem.image,
      date: listItem.date,
      category: listItem.category || 'News',
      author: 'Damascus Gin Team',
      readTime: ''
    } as BlogPostData;
  })();

  if (!post) {
    return (
      <div className="blog-post">
        <div className="container">
          <div className="post-not-found">
            <h1>Post Not Found</h1>
            <p>The blog post you're looking for doesn't exist.</p>
            <button onClick={() => navigate('/blog')} className="back-btn">
              {t(lang as Lang, 'blog.backToBlog')}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="blog-post" style={{ overflowX: 'hidden' }}>
      <div className="container">
        <div className="post-header">
          <button onClick={() => navigate('/blog')} className="back-btn">
            ← {t(lang as Lang, 'blog.backToBlog')}
          </button>
          <div className="post-meta">
            <span className="post-category">{t(lang as Lang, `blog.posts.${id}.category`)}</span>
            <span className="post-date">{new Date(post.date).toLocaleDateString()}</span>
            <span className="post-author">
              {t(lang as Lang, 'blog.by')} {t(lang as Lang, `blog.posts.${id}.author`) || t(lang as Lang, `blog.details.${id}.author`) || post.author}
            </span>
            <span className="post-read-time">
              {t(lang as Lang, `blog.posts.${id}.readTime`) || t(lang as Lang, `blog.details.${id}.readTime`) || post.readTime}
            </span>
          </div>
          <h1 className="post-title">{t(lang as Lang, `blog.posts.${id}.title`)}</h1>
          <p className="post-excerpt">{t(lang as Lang, `blog.posts.${id}.excerpt`)}</p>
        </div>
        
        <div className="post-image">
          <img 
            src={post.image} 
            alt={post.title}
            loading="lazy"
            decoding="async"
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.src = '/images/news/news-placeholder.jpg';
            }}
          />
        </div>
        
        <div
          className="post-content"
          dangerouslySetInnerHTML={{ __html: ((t(lang as Lang, `blog.posts.${id}.content`) as string) || (t(lang as Lang, `blog.details.${id}.content`) as string) || post.content) as string }}
        />
      </div>
    </div>
  );
};

export default BlogPost;
